import { useNavigate } from "react-router-dom";

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      gap: "16px",
      fontFamily: "sans-serif",
      color: "#333"
    }}>
      <div style={{ fontSize: "64px" }}>🔒</div>
      <h2 style={{ margin: 0 }}>Access Denied</h2>
      <p style={{ color: "#666", margin: 0 }}>
        You don't have permission to view this page.
      </p>
      <button
        onClick={() => navigate("/dashboard")}
        style={{
          marginTop: "8px",
          padding: "10px 24px",
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          fontSize: "14px"
        }}
      >
        Go to Dashboard
      </button>
    </div>
  );
}